interface CompressOptions {
  maxWidth?: number;
  maxHeight?: number;
  quality?: number;
}

export const compressImage = async (file: File, options: CompressOptions = {}): Promise<Blob> => {
  const { maxWidth = 1024, maxHeight = 768, quality = 0.8 } = options;

  // Create image
  const image = new Image();
  await new Promise((resolve) => {
    image.onload = resolve;
    image.src = URL.createObjectURL(file);
  });

  // Calculate new dimensions
  let width = image.width;
  let height = image.height;

  // Maintain aspect ratio
  if (width > height) {
    if (width > maxWidth) {
      height *= maxWidth / width;
      width = maxWidth;
    }
  } else {
    if (height > maxHeight) {
      width *= maxHeight / height;
      height = maxHeight;
    }
  }

  // Create canvas
  const canvas = document.createElement('canvas');
  canvas.width = width;
  canvas.height = height;
  const ctx = canvas.getContext('2d');
  if (!ctx) {
    throw new Error('Could not get canvas context');
  }

  // Draw image
  ctx.drawImage(image, 0, 0, width, height);

  // Convert to blob
  return new Promise<Blob>((resolve, reject) => {
    canvas.toBlob((blob) => {
      if (!blob) {
        reject(new Error('Failed to convert to blob'));
        return;
      }
      resolve(blob);
    }, file.type, quality);
  });


};
